const KeenSlider = window.KeenSlider
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class MobilePromoCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 16,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('mobile-promo-carousel')) {
  customElements.define('mobile-promo-carousel', MobilePromoCarousel)
}
